/**
 * Filtro de imágenes por variante para tema Horizon
 * Usa data-variant-id de los inputs para mapear variantes
 */

class VariantImagesFilter {
  constructor() {
    this.currentVariantPosition = null;
    this.variantIdToPosition = {}; // Mapeo de ID -> posición
    this.observer = null;
    this.init();
  }

  init() {
    console.log('🚀 Inicializando Variant Images Filter...');
    
    // Construir el mapeo de IDs de variante a posiciones
    this.buildVariantMap();
    
    // Escuchar cambios en los inputs de variante
    this.attachVariantListeners();
    
    // Observar cambios en el DOM
    this.observeGalleryChanges();

    // Filtrar imágenes iniciales
    this.filterInitialImages();
  }

  buildVariantMap() {
    // Encontrar todos los inputs de variante y mapearlos a posiciones
    const variantInputs = document.querySelectorAll('variant-picker input[type="radio"][data-variant-id]');
    
    variantInputs.forEach((input, index) => {
      const variantId = input.dataset.variantId;
      // La posición es index + 1 (porque las posiciones empiezan en 1)
      this.variantIdToPosition[variantId] = index + 1;
      console.log(`📍 Variante ${variantId} -> Posición ${index + 1}`);
    });

    console.log(`✅ Mapeadas ${Object.keys(this.variantIdToPosition).length} variantes`);
  }

  attachVariantListeners() {
    const variantInputs = document.querySelectorAll('variant-picker input[type="radio"][data-variant-id]');
    
    variantInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        const variantId = e.target.dataset.variantId;
        const position = this.variantIdToPosition[variantId];
        
        if (position) {
          console.log(`🔄 Cambio a variante ${variantId} (posición ${position})`);
          
          // Esperar un poco para que el DOM se actualice
          setTimeout(() => {
            this.updateGallery(position);
          }, 150);
        }
      });
    });

    console.log(`👂 Listeners agregados a ${variantInputs.length} inputs`);
  }

  observeGalleryChanges() {
    const targetNode = document.querySelector('main') || document.body;
    
    const config = {
      childList: true,
      subtree: true
    };

    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && (node.matches('media-gallery') || node.querySelector('media-gallery'))) {
            console.log('🔄 Galería reemplazada');
            
            setTimeout(() => {
              if (this.currentVariantPosition) {
                console.log(`♻️ Reaplicando filtro para posición ${this.currentVariantPosition}`);
                this.updateGallery(this.currentVariantPosition);
              }
            }, 100);
            return;
          }
        }
      }
    });

    this.observer.observe(targetNode, config);
    console.log('👁️ Observer activado');
  }

  filterInitialImages() {
    // Encontrar el input checked
    const checkedInput = document.querySelector('variant-picker input[type="radio"][data-variant-id]:checked');
    
    if (checkedInput) {
      const variantId = checkedInput.dataset.variantId;
      const position = this.variantIdToPosition[variantId];
      
      if (position) {
        console.log(`🎯 Variante inicial: ${variantId} (posición ${position})`);
        this.updateGallery(position);
        return;
      }
    }

    // Fallback a posición 1
    console.log('🎯 Usando posición 1 por defecto');
    this.updateGallery(1);
  }

  extractVariantPattern(filename) {
    const nameWithoutExt = filename.replace(/\.(jpg|jpeg|png|gif|webp|JPG|JPEG|PNG|GIF|WEBP)$/i, '');
    const match = nameWithoutExt.match(/-(\d+)-(\d+)$/);
    
    if (match) {
      return {
        variantNumber: parseInt(match[1]),
        imageNumber: parseInt(match[2])
      };
    }
    
    return null;
  }

  updateGallery(variantPosition) {
    this.currentVariantPosition = variantPosition;
    
    const mediaGallery = document.querySelector('media-gallery');
    
    if (!mediaGallery) {
      console.warn('⚠️ No se encontró media-gallery');
      return;
    }

    const allMedia = mediaGallery.querySelectorAll('.product-media-container');
    
    if (allMedia.length === 0) {
      console.warn('⚠️ No hay imágenes en la galería');
      return;
    }

    let visibleWithPattern = 0;
    let hiddenWithPattern = 0;
    let withoutPattern = 0;

    console.log(`🔍 Filtrando para variante posición ${variantPosition}...`);

    allMedia.forEach((mediaContainer) => {
      const img = mediaContainer.querySelector('img');
      
      if (!img || !img.src) return;

      const urlParts = img.src.split('/');
      const filename = urlParts[urlParts.length - 1].split('?')[0];
      
      const pattern = this.extractVariantPattern(filename);

      if (pattern) {
        if (pattern.variantNumber === variantPosition) {
          mediaContainer.style.display = '';
          mediaContainer.removeAttribute('hidden');
          visibleWithPattern++;
          console.log(`  ✅ ${filename}`);
        } else {
          mediaContainer.style.display = 'none';
          mediaContainer.setAttribute('hidden', 'true');
          hiddenWithPattern++;
          console.log(`  ❌ ${filename} (var ${pattern.variantNumber})`);
        }
      } else {
        mediaContainer.style.display = '';
        mediaContainer.removeAttribute('hidden');
        withoutPattern++;
        console.log(`  ℹ️ ${filename}`);
      }
    });

    console.log(`📊 ${visibleWithPattern} visibles | ${hiddenWithPattern} ocultas | ${withoutPattern} sin patrón`);

    this.resetSlideshow(mediaGallery);
  }

  resetSlideshow(mediaGallery) {
    const slideshow = mediaGallery.slideshow;
    
    if (!slideshow) return;

    setTimeout(() => {
      if (slideshow.select) {
        slideshow.select(0, undefined, { animate: false });
        console.log('🔄 Slideshow reiniciado');
      }
    }, 150);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Inicializar
console.log('🚀 Variant Images Filter cargando...');

let filterInstance;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    filterInstance = new VariantImagesFilter();
    console.log('✅ Filter inicializado');
  });
} else {
  filterInstance = new VariantImagesFilter();
  console.log('✅ Filter inicializado');
}
